module.exports = __webpack_public_path__ + "static/media/logo.2d03d62f.png";